import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";

import Subheader from "material-ui/Subheader";
import Paper from "material-ui-next/Paper";

import Dropzone from "react-dropzone";

import { StyledButton, TextField, SelectField } from "components/support";

import Icon from "material-ui-next/Icon";
import "./accountant-info.css";

const certificateStatusTree = {
  valid: (
    <div className="company-form__certificate__status valid">
      <Icon style={{ verticalAlign: "middle", fontSize: "2em" }}>done</Icon>{" "}
      Você já possui um certificado digital no sistema!
    </div>
  ),
  absent: (
    <div className="company-form__certificate__status absent">
      <Icon style={{ verticalAlign: "middle", fontSize: "2em" }}>warning</Icon>{" "}
      Você ainda não fez upload de um certificado digital. Sem ele não será
      possível emitir notas fiscais.
    </div>
  ),
  invalid: (
    <div className="company-form__certificate__status invalid">
      <Icon style={{ verticalAlign: "middle", fontSize: "2em" }}>
        not_interested
      </Icon>{" "}
      Ops! Parece que esse certificado está inválido ou não conseguimos ler.
    </div>
  ),
  uploaded: (
    <div className="company-form__certificate__status uploaded">
      <Icon style={{ verticalAlign: "middle", fontSize: "2em" }}>
        cloud_upload
      </Icon>{" "}
      Ótimo! Agora só precisamos que você informe a senha do certificado no
      campo abaixo.
    </div>
  )
};

const certificateButtonTextTree = {
  valid: "Trocar Certificado",
  absent: "Selecionar Certificado",
  invalid: "Selecionar outro arquivo",
  uploaded: "Selecionar outro arquivo"
};

const mN = /[0-9]/; // Number Mask
//const mAN = /[A-Za-z0-9]/ //Alpha Number Mask
export default class AccountantAreaGeneralInfoView extends Component {
  onDrop = acceptedFiles => {
    const { presenter } = this.props;
    presenter.onSelectCertificate(acceptedFiles[0]);
  };

  certificateArea = () => {
    const { company, viewModel, onChange } = this.props;
    const { errors } = this.props;
    const { certificateStatus } = viewModel;
    const buttonLabel = certificateButtonTextTree[certificateStatus];

    return (
      <div className="grid-container">
        <Row>
          <Col xs={12} className="mt-md">
            <Paper elevation={3} className="p-sm pt-md">
              <Dropzone
                onDrop={this.onDrop}
                multiple={false}
                className="company-form__certificate__dropzone"
              >
                <div className="text-center">
                  {certificateStatusTree[certificateStatus]}
                  <StyledButton>{buttonLabel}</StyledButton>
                  <span className="company-form__certificate-instruction">
                    ou arraste o arquivo até aqui.
                  </span>
                </div>
              </Dropzone>

              <TextField
                fullWidth
                underlineShow={false}
                floatingLabelFixed={true}
                floatingLabelText="Senha do certificado"
                type="password"
                value={company.fiscal_informations.certificate_password}
                onChange={(_, value) => onChange("certificate_password", value)}
                errorText={errors["fiscal_informations.certificate_password"]}
              />
            </Paper>
          </Col>
        </Row>
      </div>
    );
  };

  render() {
    const { company, onChange, errors } = this.props;
    const { fiscal_informations } = company;

    return (
      <div className="grid-container">
        <Row>
          <Col xs={12}>
            <div className="grid-container mt-sm mb-sm">
              <Row>
                <Col xs={12} lg={6}>
                  <TextField
                    fullWidth
                    underlineShow={false}
                    value={fiscal_informations.accountant_email}
                    errorText={errors["fiscal_informations.accountant_email"]}
                    onChange={(_, value) =>
                      onChange("accountant_email", value.trim())
                    }
                    floatingLabelFixed
                    floatingLabelText="E-mail da Contabilidade"
                    type="email"
                  />
                </Col>
                <Col xs={12} lg={6}>
                  <SelectField
                    floatingLabelFixed={true}
                    floatingLabelText="CRT (Código de Regime Tributário)"
                    value={fiscal_informations.crt_code}
                    errorText={errors["fiscal_informations.crt_code"]}
                    onChange={(_, value) => onChange("crt_code", value)}
                    underlineStyle={{ bottom: "0" }}
                    labelStyle={{ height: "44px" }}
                    fullWidth
                    options={[
                      { value: "", label: "Selecionar" },
                      { value: 1, label: "Simples Nacional" },
                      {
                        value: 2,
                        label:
                          "Simples Nacional – excesso de sublimite de receita bruta"
                      },
                      { value: 3, label: "Regime Normal" }
                    ]}
                  />
                </Col>
                <Col xs={12}></Col>
              </Row>
              <Row>
                <Col xs={12} lg={6}>
                  <TextField
                    fullWidth
                    underlineShow={false}
                    maxLength={14}
                    value={fiscal_informations.iest_code}
                    errorText={errors["fiscal_informations.iest_code"]}
                    onChange={(_, value) => onChange("iest_code", value.trim())}
                    floatingLabelFixed={true}
                    floatingLabelText="Código IEST"
                  />
                </Col>
                <Col xs={12} lg={6}>
                  <TextField
                    fullWidth
                    underlineShow={false}
                    value={fiscal_informations.cnae_code}
                    //errorText={errors['fiscal_informations.cnae_code']}
                    onChange={(_, value) => onChange("cnae_code", value.trim())}
                    floatingLabelFixed={true}
                    floatingLabelText="Código CNAE *"
                    maskPattern={[mN, mN, mN, mN, "-", mN, "/", mN, mN]}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} lg={6}>
                  <TextField
                    fullWidth
                    underlineShow={false}
                    value={fiscal_informations.csc}
                    onChange={(_, value) => onChange("csc", value.trim())}
                    floatingLabelFixed={true}
                    floatingLabelText="CSC (Código de Segurança do Contribuinte)*"
                    //maskPattern={[mAN, mAN, mAN, mAN, mAN, mAN, mAN, mAN, '-', mAN, mAN, mAN, mAN, '-', mAN, mAN, mAN, mAN, '-', mAN, mAN, mAN, mAN, '-', mAN, mAN, mAN, mAN, mAN, mAN, mAN, mAN, mAN, mAN, mAN, mAN]} // 8digitos - 4 digitos - 4 digitos - 4 digitos - 12 digitos
                  />
                </Col>
                <Col xs={12} lg={6}>
                  <TextField
                    fullWidth
                    underlineShow={false}
                    value={fiscal_informations.csc_id}
                    maskPattern={[mN, mN, mN, mN, mN, mN]}
                    onChange={(_, value) => onChange("csc_id", value)}
                    errorText={errors["fiscal_informations.csc_id"]}
                    floatingLabelFixed={true}
                    floatingLabelText="ID do CSC*"
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <Subheader>Certificado A1</Subheader>

                  <Row>
                    <Col xs={12}>{this.certificateArea()}</Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/accountant-area/accountant-info/view.jsx